import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/'); };

  const isAdmin = user?.role === 'admin';

  return (
    <div className="app-layout">
      <aside className="sidebar" style={{ background: '#111714' }}>
        <div className="sidebar-logo" style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', color: '#f0f0ee' }}>
          {/* <div className="logo-circle" style={{ background: '#1D9E75' }}>E</div> */}
          <img src='/Logo_or.png' alt='logoESG' style={{width:'35%'}} /><br />
          ESGcert Admin
        </div>
        <nav style={{ flex: 1 }}>
          <div className="nav-section" style={{ color: 'rgba(255,255,255,0.3)' }}>Certificatore</div>
          <NavLink to="/admin" end className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            style={({ isActive }) => ({ color: isActive ? '#fff' : 'rgba(255,255,255,0.5)', background: isActive ? 'rgba(255,255,255,0.08)' : 'transparent' })}>
            <span className="icon">📊</span> Dashboard
          </NavLink>
          <NavLink to="/admin/projects" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            style={({ isActive }) => ({ color: isActive ? '#fff' : 'rgba(255,255,255,0.5)', background: isActive ? 'rgba(255,255,255,0.08)' : 'transparent' })}>
            <span className="icon">📁</span> Tutti i progetti
          </NavLink>
          {isAdmin && (
            <>
              <div className="nav-section" style={{ color: 'rgba(255,255,255,0.3)', marginTop: 12 }}>Amministrazione</div>
              <NavLink to="/admin/users" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                style={({ isActive }) => ({ color: isActive ? '#fff' : 'rgba(255,255,255,0.5)', background: isActive ? 'rgba(255,255,255,0.08)' : 'transparent' })}>
                <span className="icon">👥</span> Utenti
              </NavLink>
            </>
          )}
        </nav>
        <div className="sidebar-footer" style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: 13 }}>
            <div style={{ fontWeight: 500, color: '#f0f0ee' }}>{user?.email?.split('@')[0]}</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginTop: 1 }}>
              {user?.role === 'admin' ? 'Amministratore' : 'Certificatore'}
            </div>
          </div>
          <button onClick={handleLogout} className="btn btn-ghost btn-sm"
            style={{ marginTop: 10, width: '100%', color: 'rgba(255,255,255,0.4)' }}>Esci</button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
